import * as React from 'react';
import { TextMessageContent, TextMessageWrapper } from './TextMessages.style';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';

type TextMessageType = 'error' | 'info';

interface TextMessagePropsType {
    className?: string;
    hasIcon?: boolean;
    marginBottom?: string;
    marginTop?: string;
    message: React.ReactNode | string;
    type: TextMessageType;
}

export const TextMessages = observer('TextMessages', (props: TextMessagePropsType): JSX.Element | null => {
    const { message, marginTop, marginBottom, className, type } = props;

    if (message === null) {
        return null;
    }

    const renderContent = (): React.ReactNode | string => {
        return (
            <>
                <UniverseComponent>
                    {({ textMessageIcons }): React.ReactElement =>
                        type === 'info' ? <textMessageIcons.infoIcon /> : <textMessageIcons.errorIcon />
                    }
                </UniverseComponent>
                <TextMessageContent>{message}</TextMessageContent>
            </>
        );
    };

    return (
        <TextMessageWrapper
            className={className}
            data-test={`text-${type}-message-content`}
            marginBottom={marginBottom}
            marginTop={marginTop}
            type={type}
        >
            {renderContent()}
        </TextMessageWrapper>
    );
});
